import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gallery, GalleryItem, Image, Overlay, Title, Description, ViewText } from "../styles/ProjectGridStyle";
import { 
  PageContainer, 
  PageHeader, 
  PageTitle,
  ContentContainer 
} from "../styles/PageTitleStyle";
import PageLayout from "../components/PageLayout";
import axios from "axios";
import Footer from "../components/Footer";
// import furnitureProjects from "../data/furnitureProjects";

function Furniture() {
  const [furniture, setFurniture] = useState([]);

  useEffect(() => {
    axios.get('http://localhost:8000/furniture')
      .then(response => {
        setFurniture(response.data);
      })
      .catch(error => {
        console.error('Error fetching furniture:', error);
      });
  }, []);

  return (
    <PageLayout>
      <PageContainer>
        <ContentContainer>
          <PageHeader>
            <PageTitle>Furniture</PageTitle>
          </PageHeader>
          <Gallery>
            {furniture.map((furniture) => (
              <Link to={`/furniture/${furniture._id}`} key={furniture._id} style={{ textDecoration: 'none' }}>
                <GalleryItem big={furniture.big}>
                  <Image src={furniture.image} alt={furniture.title} />
                  <Overlay className="overlay">
                    <Title>{furniture.title}</Title>
                    <Description>{furniture.description}</Description>
                    <ViewText>View</ViewText>
                  </Overlay>
                </GalleryItem>
              </Link>
            ))}
          </Gallery>
          <Footer />
        </ContentContainer>
      </PageContainer>
    </PageLayout>
  );
}

export default Furniture;
